export const environment = {
    APP_NAME: "cantrak",
    logLevel: 'debug',
    production: false,
    stage: true,
    v3: false,
    sourceMap: true,
    appVersion: '2.0.111',
    origin: "https://zoaca0s0ub.execute-api.ap-southeast-1.amazonaws.com/stage",
    appUrl: "https://app.staging.cantrak.tech",
    appUrl2: "https://reports.staging.cantrak.tech",
    socketOrigin: "wss://iwtaio6xg4.execute-api.ap-southeast-1.amazonaws.com/stage",
    bucketUrl: "https://cantrak-stage-resources.s3.ap-southeast-1.amazonaws.com",
    cdnUrl: "https://resources.staging.cantrak.tech",
    vapidKey: "BOzsXXXrUGlDcSb-eg1G4mFiHTdP2Ui2zkAR3Lkohmqigxq_92bMPAPnEdAEhVBQPlPiM5kZXvr6WYcwi_G-skc",
    googleClientId: "423057939767-4smipfn7q9qfmvn8p9ku121ch4kmmned.apps.googleusercontent.com",
    lazadaAppKey: "116220"
};
